import { collectiveService } from "@/common/api.service"

const initialStates = {
    status: 'loading',
    active_psp: 'loading',
    settings_status: 'loading',
    form_data: {},
    gateways: [],
    psp: [],
    general_settings: {},
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    loadingSettings(state) {
        state.settings_status = 'loading'
    },
    success(state, gateways) {
        state.status   = 'success'
        state.gateways = gateways
    },
    successShop(state, form_data) {
        state.status   = 'successShop'
        state.form_data = form_data
    },
    successSettings(state, general_settings) {
        state.settings_status  = 'success'
        state.general_settings = general_settings
    },
    activePsp(state, psp) {
        state.status = 'success'
        state.active_psp = 'loaded'
        state.psp = psp
    }
}

const getters = {
    status: ({status}) => status,
    active_psp: ({active_psp}) => active_psp,
    psp: ({psp}) => psp,
    gateways: ({gateways}) => gateways,
    settings_status: ({settings_status}) => settings_status,
    form_data: ({form_data}) => form_data,
    general_settings: ({general_settings}) => general_settings,
}

const actions = {
    fetch({commit},data) {
        commit('loading')
        return collectiveService.fetch(data).then(response => {
            commit('success', response.data.data.data)
        })
    },
    fetchGeneralSettings({commit}) {
        commit('loadingSettings')
        return collectiveService.fetchGeneralSettings().then(response => {
            commit('successSettings', response.data.data)
        })
    },
    find({commit}, hashid) {
        commit('loading')
        return collectiveService.find(hashid).then(response => {
            commit('successShop', response.data.data)
        })
    },
    findGate({commit}, hashid) {
        commit('loading')
        return collectiveService.findGate(hashid).then(response => {
            commit('successShop', response.data.data)
        })
    },
    findByShopId({commit}, {params, is_starshop = false}) {
        commit('loading')
        let findByShop = is_starshop
            ? collectiveService.findByShopId
            : collectiveService.findByShopIdOnPF;

        return findByShop(params).then(response => {
            commit('successShop', response.data.data)
        })
    },
    getActivePsp({commit}) {
        commit('loading')
        return collectiveService.getActivePsp().then(({data}) => {
            commit('activePsp', data.data)
        })
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}